const Description = ({ text }) => {
  const base =
    'text-body2Mobile md:text-body2Desktop text-umber text-center lg:text-left font-chivoMono'

  return <p className={base}>{text}</p>
}

export default Description
